import { Stack } from "@similarweb/ui-components/foundations";

import { ExpandablePanel } from "app/pages/activation/components/Shared/ExpandablePanel/ExpandablePanel";
import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";

import { InsightRow } from "./InsightRow";
import { InsightsLoader } from "./InsightsLoader";
import { InsightsTitle } from "./InsightsTitle";
import * as SC from "./styles";
import { useInsightsSection } from "./useInsightsSection";

const insightsPanelDataAutomation = generateAutomationName("home", ["insights", "panel"]);
const insightsSectionDataAutomation = generateAutomationName("home", ["insights", "section"]);

export const Insights = () => {
    const { data, isLoading, isPanelOpen, onTogglePanel, openRowIndex, onToggleInsightRow, shouldShowSection } =
        useInsightsSection();

    if (!shouldShowSection) {
        return null;
    }

    return (
        <SC.SectionRoot data-automation={insightsSectionDataAutomation}>
            <ExpandablePanel
                title={
                    <InsightsTitle
                        isPanelOpen={isPanelOpen}
                        isLoading={isLoading}
                    />
                }
                isOpen={isPanelOpen}
                onToggle={onTogglePanel}
                dataAutomation={insightsPanelDataAutomation}
            >
                {isLoading ? (
                    <InsightsLoader />
                ) : (
                    <Stack gap="12px">
                        {data.map((insight, index) => (
                            <InsightRow
                                key={`insight-${String(index)}`}
                                insight={insight}
                                index={index}
                                isOpen={openRowIndex === index}
                                onToggle={(nextOpen) => {
                                    onToggleInsightRow(index, nextOpen, insight);
                                }}
                            />
                        ))}
                    </Stack>
                )}
            </ExpandablePanel>
        </SC.SectionRoot>
    );
};
